import { Achievement_URL, POST_METHOD, Set_Achievement_URL } from '../../Apis/api';

export const setAchievementAPI = (achievementData) => {
  // alert(JSON.stringify(achievementData))
  return fetch(Set_Achievement_URL, {
    method: POST_METHOD,
    body: JSON.stringify(achievementData),
  }).then((response) => {
    return response.json();
  }).catch((e) => {
    // alert('khfjkhdskf')
  });
};

export const fetchAchievementDetails = (params) => {
  return fetch(Achievement_URL, {
    method: POST_METHOD,
    body: JSON.stringify(params),
  }).then((response) => {
    return response.json();
  });
};
